<template>
  <div id="footer">
    <div class="container">
      <div class="footer_top">
        <section class="sec1">
          <div class="left box">
            <h1 class="foot_pub_title">联系我们</h1>
            <ul class="group_info">
              <li class="item">
                <i class="iconfont icon-dianhuatianchong"></i
                ><strong>0551-63858809</strong>
              </li>
              <li class="item">
                <i class="iconfont icon-youxiang"></i
                ><strong>hr@cn-amd.com</strong>
              </li>
              <li class="item">
                <i class="iconfont icon-dingwei"></i
                ><strong
                  >中国合肥高新技术产业开发区柏堰科技园玉兰大道43号</strong
                >
              </li>
            </ul>
          </div>
          <div class="cen box">
            <ul style="height: 0.4rem"></ul>
            <ul class="foot_ewm_list">
              <li>
                <img src="../assets/img/foot_ewm1.png" alt="" /><strong
                  >中科光电公众号</strong
                >
              </li>
            </ul>
          </div>
          <!-- <div class="right box">
            <h1 class="foot_pub_title">在线留言</h1>
            <form id="defaultForm1">
              <div class="input_box input_box1">
                <input
                  type="text"
                  placeholder="姓名"
                  name="name"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='姓名'"
                />
                <input
                  type="text"
                  placeholder="联系方式"
                  tel="tel"
                  name="tel"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='联系方式'"
                />
              </div>
              <div class="input_box input_box3">
                <input
                  type="text"
                  placeholder="所在地区"
                  name="addr"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='所在地区'"
                />
                <input
                  type="text"
                  placeholder="所选物料"
                  name="material"
                  onfocus="this.placeholder=''"
                  onblur="this.placeholder='所选物料'"
                />
              </div>
              <div class="input_box input_box2">
                <div class="yzm_box">
                  <input
                    type="text"
                    name="yzm"
                    placeholder="验证码"
                    onfocus="this.placeholder=''"
                    onblur="this.placeholder='验证码'"
                  />
                  <img src="../assets/img/ssssss.png" alt="" />
                
                </div>
                <input class="sub" type="button" value="提交" />
              </div>
              <div class="form_details">
                中科光电为您提供帮助并保护您的个人隐私。
              </div>
            </form>
          </div> -->
        </section>
        <section class="sec2">
          <a href="" class="foot_logo">
            <img src="../assets/img/foot_logo.png" alt="" />
          </a>
          <ul class="foot_pro_list">
            <li><a href="">大米色选机</a></li>
            <li><a href="">杂粮色选机</a></li>
            <li><a href="">茶叶色选机</a></li>
            <li><a href="">矿石色选机</a></li>
            <li><a href="">环保色选机</a></li>
            <li><a href="">煤炭干选机</a></li>
            <li><a href="">高端视觉色选机</a></li>
          </ul>
          <nav>
            <a href="">关于中科</a>
            <a href="">视频中心</a>
            <a href="">加入中科</a>
            <a href="">投资者关系</a>
          </nav>
        </section>
      </div>
      <div class="footer_bot">
        <div class="left">
          <ul>
            <li>
              版权所有：安徽中科光电色选机械有限公司
            </li>
          </ul>
          <ul>
            <li class="first_li">
              <img src="../assets/img/gaba.png" />皖公安备案号<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34012302000182" target="_blank">34012302000182</a>
            </li>
            <li>
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">皖ICP备10004081号-1</a>
            </li>
            <li>
              <a href="http://weibo.com/zhaohuakeji" target="_blank">技术支持</a>： <a href="http://www.qiye.org.cn/" target="_blank">朝华科技</a>
            </li>
          </ul>
        </div>
        <div class="right">
          <dl class="yq_link">
            <dt>友情链接：</dt>
            <dd>
              <a href="http://www.cn-amd.com" target="_blank">中科光电</a>
            </dd>
            <dd>
              <a href="http://www.hfpress.com/" target="_blank">合锻智能</a>
            </dd>
          </dl>
          <dl class="tips_list">
            <a href="http://www.cn-amd.com/content-detail/163" target="_blank">隐私权政策</a><a href="http://www.cn-amd.com/content-detail/164" target="_blank">使用条款</a><a href="http://www.cn-amd.com/about/contact/12.html" target="_blank">问题反馈</a>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style lang="less" scoped>
#footer {
  background-color: #eef3f7;
}
.footer_top {
  border-bottom: 1px solid #d7d8da;
  padding-bottom: 0.18rem;
  padding-top: 0.6rem;
  .sec1 {
    overflow: visible;
    display: flex;
    justify-content: space-between;
    .box {
      width: 33.33%;
    }
    .left {
      .foot_pub_title {
        font-weight: bold;
        color: #333;
        font-size: 0.24rem;
        overflow: hidden;
      }
      .group_info {
        margin-top: 0.35rem;
        .item {
          line-height: 0.3rem;
          font-size: 0.16rem;
          strong {
            font-size: 0.14rem;
            color: #666;
            font-weight: normal;
          }
        }
      }
    }
    .cen {
      .foot_ewm_list {
        display: flex;
        justify-content: flex-end;
        li {
          margin: 0 0.2rem;
          img {
            width: 1.1rem;
            height: auto;
          }
          strong {
            font-weight: normal;
            font-size: 0.14rem;
            color: #666;
            margin-top: 0.08rem;
            display: block;
          }
        }
      }
    }
    .right {
      .foot_pub_title {
        font-weight: bold;
        color: #333;
        font-size: 0.24rem;
        overflow: hidden;
      }
      #defaultForm1 {
        margin-top: 0.26rem;
        overflow: hidden;
        margin-bottom: 0.1rem;
        .input_box {
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.1rem;
          input {
            width: 1.9rem;
            height: 0.4rem;
            padding: 0 0.1rem;
            border-radius: 5px;
            border: 1px solid #b4b6b7;
            background-color: transparent;
            transition: all 0.3s;
          }
          .yzm_box {
            position: relative;
            overflow: hidden;
            input {
              width: 2.2rem;
              padding-right: 1.1rem;
            }
            img {
              width: 1rem;
              height: 0.38rem;
              position: absolute;
              top: 1px;
              right: 1px;
              cursor: pointer;
            }
          }
          .sub {
            color: #4d81d5;
            width: 1.6rem;
            border-color: #4d81d5;
            cursor: pointer;
          }
          .sub:hover {
            background-color: #4d81d5;
            color: #fff;
          }
        }
        .form_details {
          font-size: 0.14rem;
          color: #666;
        }
      }
    }
  }
  .sec2 {
    margin-top: 0.4rem;
    height: 0.3rem;
    a {
      float: left;
    }
    .foot_pro_list {
      float: left;
      display: flex;
      margin-left: 0.22rem;
      transform: translateY(5px);
      li {
        margin-right: 0.1rem;
        a {
          font-size: 0.14rem;
          color: #666;
        }
      }
    }
    nav {
      transform: translateY(5px);
      float: right;
      a {
        margin-left: 0.1rem;
        font-size: 0.14rem;
        color: #666;
      }
    }
  }
}
.footer_bot {
  width: 100%;
  overflow: hidden;
  padding-top: 0.18rem;
  padding-bottom: 0.3rem;
  .left {
    float: left;
    ul {
      li {
        display: flex;
        padding-right: 0.1rem;
        line-height: 0.18rem;
        color: #666;
        font-size: 0.14rem;
        a {
          padding-right: 0.1rem;
          line-height: 0.18rem;
          color: #666;
          font-size: 0.14rem;
        }
      }
      .first_li {
        img {
          width: auto;
          height: auto;
          display: inline-block;
          margin-right: 5px;
        }
        a {
          color: #666;
          transition: color 0.3s;
        }
      }
    }
    ul:last-child {
      margin-top: 0.05rem;
      display: flex;
    }
  }
  .right {
    float: right;
    .yq_link {
      display: flex;
      dt {
        color: #666;
        transition: color 0.3s;
        font-size: 0.14rem;
        line-height: 0.24rem;
      }
      dd {
        margin-left: 0.1rem;
        a {
          color: #666;
          transition: color 0.3s;
          font-size: 0.14rem;
        }
      }
    }
    .tips_list {
      text-align: right;
      margin-top: 0.05rem;
      a {
        margin-left: 0.15rem;
        color: #666;
        transition: color 0.3s;
        font-size: 0.14rem;
      }
    }
  }
}
@media only screen and (max-width: 766px) {
  .footer_top {
    .sec1 {
      padding: 0 0.2rem;
      .left {
        .foot_pub_title {
          font-size: 0.36rem;
        }
        .group_info {
          .item strong {
            font-size: 0.24rem;
          }
        }
      }
      .right {
        display: none;
      }
      .box {
        width: 50%;
      }
      .cen {
        .foot_ewm_list {
          .item strong {
            font-size: 0.24rem;
          }
        }
      }
    }
    .sec2 {
      display: none;
    }
  }
  .footer_bot {
    .right {
      display: none;
    }
    .left {
      ul {
        li {
          line-height: 0.3rem;
          font-size: 0.24rem;
          a {
            font-size: 0.24rem;
            line-height: 0.3rem;
          }
        }
      }
      ul:nth-child(2) {
        display: block;
        li {
          float: left;
        }
      }
    }
  }
}
</style>
